import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";
import AuthShell from "../components/AuthShell";
import { toast } from "sonner";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

const FORGOT_HERO = "https://static.prod-images.emergentagent.com/jobs/8e4196d6-aa64-413e-8d09-93aaa7923fd4/images/81d661c59dd94452674038a69ba4e3d5fb9d6ff4518fc955a572c660c4272fe6.png";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Something went wrong. Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <SEO title="Reset your password — Energize.fit" path="/forgot-password" noindex />
            <AuthShell
                testid="forgot-shell"
                heroImage={FORGOT_HERO}
                heroQuote="Take a breath. We’ll get you back in."
                heroAttrib="Reset securely — link expires in 1 hour."
                heading={done ? "Check your inbox." : "Forgot your password?"}
                sub={done
                    ? `If there's an Energize.fit account for ${email}, we've sent a link to reset your password.`
                    : "Enter your email and we'll send you a one-time reset link."}
            >
                <Link to="/login" className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-stone-900 mb-8" data-testid="forgot-back">
                    <ArrowLeft className="w-4 h-4" /> Back to login
                </Link>
                {done ? (
                    <div data-testid="forgot-success">
                        <div className="h-14 w-14 rounded-full bg-teal-50 text-teal-700 flex items-center justify-center mb-5">
                            <CheckCircle2 className="w-7 h-7" />
                        </div>
                        <p className="text-sm text-stone-500">
                            Didn't get it? Check your spam folder, or <button onClick={() => setDone(false)} className="text-stone-900 underline underline-offset-4" data-testid="forgot-try-again">try again</button>.
                        </p>
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
                        <div>
                            <label className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500 mb-2 block">Email</label>
                            <input type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="w-full bg-white border border-stone-200 rounded-xl px-4 py-3 focus:ring-2 focus:ring-teal-500/40 focus:border-teal-500 outline-none transition" />
                        </div>
                        <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-stone-900 hover:bg-stone-800 text-white rounded-full px-6 py-4 font-medium hover:-translate-y-0.5 transition-all disabled:opacity-60">
                            {loading ? "Sending link…" : "Send reset link"}
                        </button>
                    </form>
                )}
            </AuthShell>
        </>
    );
}
